import { FC } from "react";
import { IPurchaseCardProps } from "../card/types";
import { IPurchase } from "@stores/purchases/types";
import { isDevPlan, isEnterprisePlan } from "@common/utils/plan";
import UnsupportedPurchaseCard from "../card/UnsupportedPurchaseCard";
import SelfHostedPurchaseCard from "../card/SelfHostedPurchaseCard";
import SelfHostedDevPurchaseCard from "../card/SelfHostedDevPurchaseCard";
import CloudDevPurchaseCard from "../card/CloudDevPurchaseCard";
import CloudPurchaseCard from "../card/CloudPurchaseCard/CloudPurchaseCard";
import EnterpriseCloudPurchaseCard from "../card/EnterpriseCloudPurchaseCard";
import EnterpriseSelfHostedPurchaseCard from "../card/EnterpriseSelfHostedPurchaseCard";

export function getPurchaseCard(purchase: IPurchase): FC<IPurchaseCardProps> {
  const isCloudHosted = !!purchase.hosted_instance;
  const isSelfHosted = !isCloudHosted && purchase.token;
  const isDev = isDevPlan(purchase.product.plan.alias);
  const isEnterprise = isEnterprisePlan(purchase.product.plan.alias);

  if (isEnterprise) {
    return isCloudHosted
      ? EnterpriseCloudPurchaseCard
      : EnterpriseSelfHostedPurchaseCard;
  }

  if (isCloudHosted) {
    return isDev ? CloudDevPurchaseCard : CloudPurchaseCard;
  }

  if (isSelfHosted) {
    return isDev ? SelfHostedDevPurchaseCard : SelfHostedPurchaseCard;
  }

  return UnsupportedPurchaseCard;
}
